var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"infoCont"},[_vm._t("content",function(){return [_c('p',{staticClass:"txtLeft"},[_vm._v(_vm._s(_vm.label))]),_vm._t("right",function(){return [_c('p',{staticClass:"txtRight"},[_vm._t("default",function(){return [_c('span',[_vm._v(_vm._s(_vm.value))])]})],2)]})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }